
import React, { useState, useContext, useEffect } from 'react';
import { Button, Modal, Form, Input, DatePicker, Select, message} from 'antd';
import axios from 'axios';
import { ShopOutlined } from '@ant-design/icons'
import { fetchData } from './listRevenueShare';

const API_URL = process.env.REACT_APP_API_URL

export var getBranch = ''

const AddFanshine = () => {
    const [open, setOpen] = useState(false);
    const [branch, setBranch] = useState([])
    const [form] = Form.useForm();
    const token = localStorage.getItem('Authentication');
    const [messageApi, contextHolder] = message.useMessage();


    const onSuccess = () => {
        messageApi.open({
            type: 'success',
            content: 'เพิ่มส่วนแบ่งรายได้สาขาเรียบร้อย',
        });
    }

    useEffect(() => {
        getBranch();
    },[])

    getBranch = async () => {
        try {
            const response = await axios.get(`${API_URL}getNewBranchRevenueShare`,
                {
                    headers: { 'Authorization': `bearer ${token}` }
                })
            setBranch(response.data);

        } catch (error) {
            console.log(error);
        }
    }


    const createFanshine = async (values) => {
        setBranch('')
        try {
            const response = await axios.post(`${API_URL}createRevenueShareBranch`,
                {
                    branch: values.branch,
                    shareHolder: values.shareHolder,
                    shareRate: values.shareRate,
                    effectiveDate: values.effectiveDate
                },
                {
                    headers: {
                        'Authorization': `bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            if (response.status === 200) {
                    fetchData();
                    onSuccess();
                    getBranch();
            } else {
                console.error('Failed to Revenue Share:', response.statusText);
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    return (
        <>
            {contextHolder}
            <Button type="primary" onClick={() => setOpen(true)}>
                <ShopOutlined />
                เพิ่มสาขาส่วนแบ่งรายได้
            </Button>
            <Modal
                title="เพิ่มสาขาส่วนแบ่งรายได้"
                centered
                open={open}
                okText="ยืนยัน"
                cancelText="ยกเลิก"
                onOk={() => {
                    form
                        .validateFields()
                        .then((values) => {
                            createFanshine(values)
                            form.resetFields();
                            setOpen(false);
                        })
                        .catch((errorInfo) => {
                            console.log('Failed:', errorInfo);
                        });
                }}
                onCancel={() => {
                    form.resetFields();
                    setOpen(false);
                }}
                width={400}
            >
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Form.Item name="branch" label="สาขา"
                        rules={[
                        {
                            required: true,
                            message: 'กรุณาเลือกสาขา',
                        }]} >
                        <Select
                            allowClear
                            optionFilterProp="label">
                            {branch ? branch.map(branchItem => (
                                <Select.Option key={branchItem.id} value={branchItem.id} label={branchItem.name}>{branchItem.name}</Select.Option>
                            )) : ''}
                        </Select>
                    </Form.Item>
                    <Form.Item name="shareRate" label="ส่วนแบ่งรายได้ (%)"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกส่วนแบ่งรายได้',
                            },
                        ]}>
                        <Input type='number' min={0} max={100} step={0.5}/>
                    </Form.Item>
                    <Form.Item name="shareHolder" label="ชื่อผู้รับส่วนแบ่ง"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกชื่อผู้รับส่วนแบ่ง',
                            },
                        ]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item name="effectiveDate" label="วันที่เริ่มเก็บส่วนแบ่งรายได้"
                        rules={[
                            {
                                required: true,
                                message: 'กรุณากรอกวันที่เริ่มเก็บส่วนแบ่งรายได้',
                            },
                        ]}>
                        <DatePicker/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};
export default AddFanshine;